module.exports = __webpack_public_path__ + "img/home_closed.677e6323.png";